import ConnectorsGrid from './ConnectorsGrid'

export function AvailableConnectors({ connectors }) {
  if (!connectors?.length) {
    return null
  }
  return <ConnectorsGrid connectors={connectors} />
}
